module.exports = __webpack_public_path__ + "img/chips10.a8063091.png";